import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpv-attribute',
  templateUrl: './attribute.component.html',
  styleUrls: ['./attribute.component.css']
})
export class AttributeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
